import type { IntegrationProviderConfig } from './types';
import { wordPressConfig } from './providers/wordpress/WordPressConfig';
import { slackConfig } from './providers/slack/SlackConfig';
import { zapierConfig } from './providers/zapier/ZapierConfig';
import { notionConfig } from './providers/notion/NotionConfig';

const integrationRegistry = new Map<string, IntegrationProviderConfig>();

export function registerProvider(config: IntegrationProviderConfig): void {
  integrationRegistry.set(config.id, config);
}

export function getProvider(id: string): IntegrationProviderConfig | undefined {
  return integrationRegistry.get(id);
}

export function getAllProviders(): IntegrationProviderConfig[] {
  return Array.from(integrationRegistry.values());
}

export function getProviderIds(): string[] {
  return Array.from(integrationRegistry.keys());
}

export { integrationRegistry };

registerProvider(wordPressConfig);
registerProvider(slackConfig);
// registerProvider(zapierConfig);
// registerProvider(notionConfig);
